import {
    NAV_ITEM_TYPE_COLLAPSE,
    NAV_ITEM_TYPE_ITEM,
} from 'constants/navigation.constant'

const navigationConfig = [
    {
        key: 'home',
        path: '/home',
        title: 'Project Overview',
        translateKey: 'projectOverview',
        icon: 'HiOutlineHome',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
		permission:300,
    },
    {
        key: 'activityBoard',
        path: '/activity-board',
        title: 'Activity Board',
        translateKey: 'activityBoard',
        icon: 'HiOutlineChartSquareBar',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
		permission:300,
    },
    {
        key: 'inspection',
        path: '/inspection',
        title: 'Inspection Board',
        translateKey: 'inspectionBoard',
        icon: 'HiOutlineCalendar',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
        permission:300,
        badge: 'Pro+',
    },
    {
        key: 'siteInstraction',
        path: '/site-instraction',
        title: 'Site Instraction',
        translateKey: 'siteInstraction',
        icon: 'HiOutlineClipboardCheck',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
        permission:300,
        badge: 'Pro',
    },
    {
        key: 'progressPhotos',
        path: '/progress-photos',
        title: 'Progress Photos',
        translateKey: 'progressPhotos',
        icon: 'HiOutlinePhotograph',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
        permission:300,
    },
    {
        key: 'sendReports',
        path: '/send-reports',
        title: 'Reporting Daily Activities',
        translateKey: 'reportingDailyActivies',
        icon: 'HiOutlineDuplicate',
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
        permission:300,
    },
    {
        key: 'reports',
        path: 'reports',
        title: 'Reports',
        translateKey: 'reports',
        icon: 'HiOutlineChartPie',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: [],
		permission:300,
        subMenu: [
            {
                key: 'dailyReports',
                path: '/daily-reports',
                title: 'Daily Reports',
                translateKey: 'dailyReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'workReports',
                path: '/work-reports',
                title: 'Work Reports',
                translateKey: 'workReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'manpowerReports',
                path: '/manpower-reports',
                title: 'Manpower Reports',
                translateKey: 'manpowerReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'equipmentReports',
                path: '/equipment-reports',
                title: 'Equipment Reports',
                translateKey: 'equipmentReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'hseReports',
                path: '/hse-reports',
                title: 'Hse Reports',
                translateKey: 'hseReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'QaReports',
                path: '/qa-qc-reports',
                title: 'QA/QC Reports',
                translateKey: 'QaReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'GelenMalzemeReports',
                path: '/incoming-material-reports',
                title: 'Incoming Material Reports',
                translateKey: 'GelenMalzemeReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
            {
                key: 'WeatherReports',
                path: '/weather-reports',
                title: 'Weather Reports',
                translateKey: 'WeatherReports',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: [],
                subMenu: [],
                permission:300,
            },
        ],
    },
    {
        key: 'uiComponent',
        path: '',
        title: 'Settings',
        translateKey: 'ayarlar',
        icon: 'HiOutlineCog',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: ['USERADMIN', 'Admin'],
		permission:300,
        subMenu: [
            {
                key: 'kullanicilar',
                path: '/kullanicilar',
                title: 'Users',
                translateKey: 'kullanicilar',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['USERADMIN', 'Admin'],
                subMenu: [],
                permission:300,
            },
            {
                key: 'subcontractors',
                path: '/subcontractors',
                title: 'Subcontractors',
                translateKey: 'subcontractors',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['USERADMIN', 'Admin'],
                subMenu: [],
                permission:300,
            },
            {
                key: 'projelerim',
                path: '/projelerim',
                title: 'My Projects',
                translateKey: 'projelerim',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['USERADMIN', 'Admin'],
                subMenu: [],
                permission:300,
            },
            {
                key: 'projeAyarlarim',
                path: '/proje-ayarlarim',
                title: 'Proje Ayarlarım',
                translateKey: 'projeAyarlarim',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['USERADMIN', 'Admin'],
                subMenu: [],
                permission:300,
            }
        ]
    },
    {
        key: 'uiComponent',
        path: '',
        title: 'Management',
        translateKey: 'managementMenu',
        icon: 'HiOutlineCog',
        type: NAV_ITEM_TYPE_COLLAPSE,
        authority: ['SUPERADMIN'],
		permission:301,
        subMenu: [
            {
                key: 'userYonetimi',
                path: '/kullanici-yonetimi',
                title: 'User Management',
                translateKey: 'userYonetimi',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['SUPERADMIN'],
                subMenu: [],
                permission:301,
            },
            {
                key: 'projeYonetimi',
                path: '/proje-yonetimi',
                title: 'Project Management',
                translateKey: 'projeYonetim',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['SUPERADMIN'],
                subMenu: [],
                permission:301,
            },
            {
                key: 'defaultYonetimi',
                path: '/default-yonetimi',
                title: 'Default Contents',
                translateKey: 'defaultYonetim',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['SUPERADMIN'],
                subMenu: [],
                permission:301,
            },
            {
                key: 'langManagement',
                path: '/languages',
                title: 'Lang Management',
                translateKey: 'langManagement',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['SUPERADMIN'],
                subMenu: [],
                permission:-1,
                projectId:2
            },
            {
                key: 'genelAyarlar',
                path: '/genel-ayarlar',
                title: 'General Settings',
                translateKey: 'genelAyarlar',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                authority: ['SUPERADMIN'],
                subMenu: [],
                permission:301,
            }
        ]
    }
]

export default navigationConfig
